import { Component, Input } from '@angular/core';
import { MartOrderDetailsComponent } from 'app/mart';

@Component({
    selector: 'mart-order-details-timeline-tab',
    templateUrl: './mart-order-details-timeline-tab.component.html',
    styleUrls: [
        './mart-order-details-timeline-tab.component.scss',
        '../mart-order-details.component.scss'
    ]
})
export class MartOrderDetailsTimelineTabComponent {
    @Input()
    public parent!: MartOrderDetailsComponent;
}
